import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function CaidsReducer(state = initialState.caids, action: any) {
  switch (action.type) {
    case types.SAVE_CAIDS_SUCCESS:
      return action.caids;
    default:
      return state;
  }
}
